module.exports = __webpack_public_path__ + "media/navigation/icon-pouch-848d5d7b.svg";